<template>
  <table class="table table-hover">
    <thead>
      <tr>
        <th
          v-for="(col, idx) in columns"
          v-bind:key="idx"
          v-on:mouseup="sortColumn(col.idx)"
          v-bind:class="{ 'text-center': col.center }"
          v-bind:aria-sort="ariaSort(col.idx)"
          class="c-hand"
        >
          {{ col.name }}<sub v-if="col.sub">{{ col.sub }}</sub>
          <span v-if="sortArrow(col.idx)">&nbsp;{{ sortArrow(col.idx) }}</span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(t, idx) in lines"
        v-bind:key="idx"
        v-on:mouseup="navigateToLine(t.idx)"
        class="c-hand"
      >
        <td>{{ t.line[F_BUS] }}</td>
        <td>{{ t.line[T_BUS] }}</td>
        <td class="text-right">
          <span v-if="t.line[VF]">
            {{ t.line[VF] }}<span class="hide-sm"> pu</span>
          </span>
        </td>
        <td class="text-right">
          <span v-if="t.line[VT]">
            {{ t.line[VT] }}<span class="hide-sm"> pu</span>
          </span>
        </td>
        <td class="text-right">
          <span v-if="t.line[PMIN]">
            {{ t.line[PMIN] }}<span class="hide-sm"> MW</span>
          </span>
        </td>
        <td class="text-right">
          <span v-if="t.line[PMAX]">
            {{ t.line[PMAX] }}<span class="hide-sm"> MW</span>
          </span>
        </td>
        <td class="text-right">
          <span v-if="t.line[LOSS0]">{{ t.line[LOSS0] }}</span>
        </td>
        <td class="text-right">
          <span v-if="t.line[LOSS1]">{{ t.line[LOSS1] }}</span>
        </td>
        <td class="text-center">
          <i v-if="t.line[BR_STATUS]" class="icon icon-check"></i>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import MPCStore from "../../stores/MPCStore";

import {
  DCLINE_F_BUS,
  DCLINE_T_BUS,
  DCLINE_BR_STATUS,
  DCLINE_PF,
  DCLINE_PT,
  DCLINE_QF,
  DCLINE_QT,
  DCLINE_VF,
  DCLINE_VT,
  DCLINE_PMIN,
  DCLINE_PMAX,
  DCLINE_QMINF,
  DCLINE_QMAXF,
  DCLINE_QMAXT,
  DCLINE_QMINT,
  DCLINE_LOSS0,
  DCLINE_LOSS1
} from "../../stores/idx";

export default {
  name: "DCLineTable",
  data() {
    return {
      columns: [
        { idx: DCLINE_F_BUS, name: "From" },
        { idx: DCLINE_T_BUS, name: "To" },
        { idx: DCLINE_VF, name: "V", sub: "f", center: true },
        { idx: DCLINE_VT, name: "V", sub: "t", center: true },
        { idx: DCLINE_PMIN, name: "P", sub: "min", center: true },
        { idx: DCLINE_PMAX, name: "P", sub: "max", center: true },
        { idx: DCLINE_LOSS0, name: "l", sub: "0", center: true },
        { idx: DCLINE_LOSS1, name: "l", sub: "1", center: true },
        { idx: DCLINE_BR_STATUS, name: "Status", center: true }
      ],
      sorted: -1,
      ascending: false,

      F_BUS: DCLINE_F_BUS,
      T_BUS: DCLINE_T_BUS,
      VF: DCLINE_VF,
      VT: DCLINE_VT,
      PMIN: DCLINE_PMIN,
      PMAX: DCLINE_PMAX,
      QMINF: DCLINE_QMINF,
      QMAXF: DCLINE_QMAXF,
      QMINT: DCLINE_QMINT,
      QMAXT: DCLINE_QMAXT,
      LOSS0: DCLINE_LOSS0,
      LOSS1: DCLINE_LOSS1,
      BR_STATUS: DCLINE_BR_STATUS,
      PF: DCLINE_PF,
      PT: DCLINE_PT,
      QF: DCLINE_QF,
      QT: DCLINE_QT
    };
  },
  computed: {
    lines() {
      let idx = this.sorted;
      let up = this.ascending;
      return MPCStore.methods
        .getDCLines()
        .map((line, idx) => ({ line, idx }))
        .sort(function(a, b) {
          if (idx >= 0) {
            return up ? b.line[idx] - a.line[idx] : a.line[idx] - b.line[idx];
          }
          return 0;
        });
    }
  },
  methods: {
    navigateToLine(idx) {
      this.$router.push({ name: "dcline", params: { ord: idx + 1 } });
    },
    sortColumn(idx) {
      if (this.sorted === idx) {
        this.ascending = !this.ascending;
      } else {
        this.sorted = idx;
        this.ascending = false;
      }
    },
    ariaSort(idx) {
      if (this.sorted === idx) {
        return this.ascending ? "ascending" : "descending";
      }
      return "none";
    },
    sortArrow(idx) {
      if (this.sorted === idx) {
        return this.ascending ? "▴" : "▾";
      }
    }
  }
};
</script>
